var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9331 6.6295C13.957 6.51723 13.9432 6.4002 13.8938 6.29659C13.8443 6.19299 13.7621 6.10861 13.6598 6.05658C13.5574 6.00455 13.4408 5.98778 13.328 6.00887C13.2151 6.02996 13.1124 6.08774 13.0358 6.17322L7.13264 12.7709C7.0656 12.8458 7.0217 12.9386 7.00621 13.0379C6.99073 13.1373 7.00433 13.239 7.04538 13.3307C7.08643 13.4225 7.15317 13.5005 7.23754 13.5552C7.32191 13.6099 7.42031 13.639 7.52086 13.639H12.085L11.1787 17.8705C11.1548 17.9828 11.1686 18.0998 11.218 18.2034C11.2675 18.307 11.3497 18.3914 11.4521 18.4434C11.5544 18.4955 11.671 18.5122 11.7839 18.4911C11.8967 18.47 11.9994 18.4123 12.076 18.3268L17.9792 11.7291C18.0462 11.6542 18.0901 11.5614 18.1056 11.4621C18.1211 11.3627 18.1075 11.261 18.0664 11.1693C18.0254 11.0775 17.9586 10.9995 17.8743 10.9448C17.7899 10.8901 17.6915 10.861 17.591 10.861H13.0268L13.9331 6.6295Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolts);
export default __webpack_public_path__ + "static/media/bolts.20cdc43402aed1eda27c05eb59cb1fc1.svg";
export { ForwardRef as ReactComponent };